import React from "react";

const SignupSidebar = ({ sideBarState }) => {
  // A helper function to get the right CSS class
  const getStepClass = (step) => {
    if (!step) return "muted"; // fallback
    if (step.isActive) return "active";
    if (step.isCompleted) return "completed";
    return "muted";
  };

  return (
    <div
      className="col-md-4 px-5 py-3 d-flex flex-column"
      style={{ minHeight: "100%" }}
    >
      <div className="row">
        <div className="col-md-12 mt-4">
          <img src="/images/logo.svg" height="65px" alt="Logo" />
        </div>

        <div className="col-md-12 mt-5">
          <ol className="steps">
            <li className={getStepClass(sideBarState?.aboutCompany)}>
              <div className="step-item">
                <span className="step-number">1.</span>
                <div>
                  <h3>About company</h3>
                  <p>Signup - company</p>
                </div>
              </div>
            </li>

            <li className={getStepClass(sideBarState?.aboutYou)}>
              <div className="step-item">
                <span className="step-number">2.</span>
                <div>
                  <h3>Who are you?</h3>
                  <p>About you</p>
                </div>
              </div>
            </li>

            <li className={getStepClass(sideBarState?.setPassword)}>
              <div className="step-item">
                <span className="step-number">3.</span>
                <div>
                  <h3>Set a password</h3>
                  <p>Enter the following details!</p>
                </div>
              </div>
            </li>
          </ol>
        </div>
      </div>

      {/* Bottom Info */}
      <div className="mt-auto">
        <div
          className="d-flex align-items-start"
          style={{ marginBottom: "100px" }}
        >
          <i className="fa fa-info-circle mr-2 mt-1" aria-hidden="true"></i>
          <p
            className={`info-txt mb-0 ${
              sideBarState.aboutCompany.isActive ||
              sideBarState.aboutYou.isActive ||
              sideBarState.setPassword.isActive
                ? ""
                : "muted"
            }`}
          >
            But why? we need this information to <br /> personalise the
            onboarding process.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignupSidebar;
